import * as React from "react";
import { getS3Variant } from "archive/logic/s3CompatibleProviders";
import S3CredentialsFieldGroup, {
  validateS3CredentialsFields
} from "data-tiering/repository-management/S3CredentialsFieldGroup";
import {
  isS3CompatibleRepositoryType,
  S3_AUTH_MODE,
  STORAGE_REPOSITORY_TYPE
} from "data-tiering/repository-management/types";
import S3CredentialsFormFields, {
  validateS3CredentialsForm
} from "data-tiering/warm-tier-repositories/S3CredentialsFormFields";
const S3CreateFields = ({ type }) => /* @__PURE__ */ React.createElement(S3CredentialsFieldGroup, { variant: getS3Variant(type) });
const S3EditFields = ({ record }) => {
  var _a;
  return /* @__PURE__ */ React.createElement(S3CredentialsFormFields, { secretIsSet: !!((_a = record == null ? void 0 : record.aws_secret_access_key) == null ? void 0 : _a.is_set) });
};
const initialEditValues = (stored) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const record = stored;
  return record ? {
    provider: (_a = record.provider) != null ? _a : STORAGE_REPOSITORY_TYPE.S3,
    auth_mode: record.auth_mode,
    aws_access_key_id: (_b = record.aws_access_key_id) != null ? _b : void 0,
    aws_secret_access_key: ((_c = record.aws_secret_access_key) == null ? void 0 : _c.is_set) ? { keep_value: true } : void 0,
    aws_region: (_d = record.aws_region) != null ? _d : void 0,
    endpoint_uri: (_e = record.endpoint_uri) != null ? _e : void 0,
    aws_assume_role_arn: (_f = record.aws_assume_role_arn) != null ? _f : void 0,
    aws_external_id: (_g = record.aws_external_id) != null ? _g : void 0
  } : { provider: STORAGE_REPOSITORY_TYPE.S3, auth_mode: "key_secret" };
};
const toUpdatePayload = (values) => {
  var _a, _b;
  return {
    provider: values.provider,
    auth_mode: values.auth_mode,
    aws_access_key_id: values.auth_mode === "key_secret" && values.aws_access_key_id || null,
    aws_secret_access_key: values.auth_mode === "key_secret" ? values.aws_secret_access_key : void 0,
    aws_region: (_a = values.aws_region) != null ? _a : null,
    endpoint_uri: (_b = values.endpoint_uri) != null ? _b : null,
    aws_assume_role_arn: values.provider === STORAGE_REPOSITORY_TYPE.S3 && values.aws_assume_role_arn || null,
    aws_external_id: values.provider === STORAGE_REPOSITORY_TYPE.S3 && values.aws_external_id || null
  };
};
const s3Definition = {
  create: {
    initialValues: (type) => ({
      auth_mode: isS3CompatibleRepositoryType(type) ? S3_AUTH_MODE.KEY_SECRET : S3_AUTH_MODE.AUTOMATIC,
      aws_access_key_id: void 0,
      aws_secret_access_key: void 0,
      aws_region: void 0,
      endpoint_uri: void 0,
      aws_assume_role_arn: void 0,
      aws_external_id: void 0
    }),
    validate: (credentials) => validateS3CredentialsFields(credentials),
    Fields: S3CreateFields
  },
  edit: {
    initialValues: initialEditValues,
    validate: (values) => validateS3CredentialsForm(values),
    toPayload: (values) => toUpdatePayload(values),
    Fields: S3EditFields
  }
};
export default s3Definition;
